import React, { Component } from 'react';
import Service from '../../services';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { baseUrlAdmin } from '../../store/apiConstants';
import LoadingComponent from '../loadingComponent';
import { Toast } from 'primereact/toast';
import BranchToSectionDDPreFill from '../BaseDropdownComponents/BranchToSectionDDPreFill';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { exportToExcel } from '../../utils/excelExport';

class StudentWiseErrorsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            exams: [],
            selectedExam: null,
            filteredData: [],
            rawData: [],
            dataTableKey: 0,
            tableLoading: false,
            dropdownsData: {},
        };
        this.service = new Service();
    }

    setDropdownValues = (dropdownsData) => {
        this.setState({
            dropdownsData
        }, () => {
            if (dropdownsData.branchId && dropdownsData.sectionId) {
                this.getStudentWiseErrorsReportInfo();
            }
        });
    }

    getStudentWiseErrorsReportInfo() {
        const { dropdownsData } = this.state;
        this.setState({ tableLoading: true });

        this.service.post(`${baseUrlAdmin}/academicsReports/studentWiseErrorsReport`, {
            academicYear: localStorage.getItem('userAcademicYear'),
            branchId: dropdownsData.branchId,
            sectionId: dropdownsData.sectionId
        }, true)
            .then((response) => {
                if (response.status && response?.res?.status) {
                    const exams = response.res.data.map(item => ({
                        examId: item.examId,
                        examName: item.examName
                    })).filter((exam, index, self) =>
                        index === self.findIndex((e) => e.examId === exam.examId)
                    );

                    this.setState({
                        rawData: response.res.data,
                        exams,
                        tableLoading: false,
                        selectedExam: null,
                        filteredData: []
                    });
                } else {
                    this.setState({ tableLoading: false });
                }
            })
            .catch((error) => {
                this.setState({ tableLoading: false });
                this.toast?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch report data',
                    life: 3000
                });
            });
    }

    onExamChange = (selectedExam) => {
        const filteredData = this.state.rawData.filter(item =>
            item.examId === selectedExam.examId
        );
        this.setState({
            selectedExam,
            filteredData,
            dataTableKey: this.state.dataTableKey + 1
        });
    };

    onViewAnalysis = () => {
        const { rawData, selectedExam } = this.state;

        // Filter data based on selected exam, branch and section
        const filteredData = rawData.filter(item =>
            item.examId === selectedExam
        );

        this.setState({ filteredData });
    };

    render() {
        const { exams, selectedExam, filteredData, dataTableKey, tableLoading } = this.state;

        const transformedData = filteredData.map((item) => {
            let rowData = {
                enrollmentId: item.enrollmentId,
                studentName: item.studentName,
                totalMarks: `${item.totalMarks} (${item.rank})`
            };
            item.subjectErrors.forEach(subject => {
                rowData[`${subject.subjectName}_wrong`] = subject.wrongAnswers.length > 0 ? subject.wrongAnswers.join(', ') : '-';
                rowData[`${subject.subjectName}_notAttempted`] = subject.notAttempted.length > 0 ? subject.notAttempted.join(', ') : '-';
            });
            return rowData;
        });

        const subjects = filteredData.length > 0 ? filteredData[0].subjectErrors.map(subject => subject.subjectName) : [];

        // Inside the render method, create columns configuration
        const columns = [
            { field: 'enrollmentId', header: 'Enrollment Code' },
            { field: 'studentName', header: 'Student Name' },
            { field: 'totalMarks', header: 'Total Marks (Overall Rank)' },
            ...subjects.flatMap(subjectName => [
                { 
                    field: `${subjectName}_wrong`, 
                    header: `${subjectName} Q.Nos WRONGLY ANSWERED` 
                },
                { 
                    field: `${subjectName}_notAttempted`, 
                    header: `${subjectName} Q.Nos NOT ATTEMPTED` 
                }
            ])
        ];

        return (
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, padding: '0', marginLeft: "100px", marginTop: "55px", overflow: 'auto' }}>
                <div className="card filters-card mt-1 pt-0">
                    <BranchToSectionDDPreFill setValues={this.setDropdownValues} />

                    <div className="grid m-2">
                        <div className="col-3">
                            <label className='label'>Exam <span style={{ color: 'red' }}>*</span></label>
                            <div className="mt-2">
                                <ClassetDropdown
                                    value={selectedExam}
                                    options={exams}
                                    onChange={(e) => this.onExamChange(e.value)}
                                    optionLabel="examName"
                                    optionValue="examId"
                                    placeholder="Select Exam"
                                    disabled={!exams.length}
                                />
                            </div>
                        </div>
                        {/* View Analysis Button */}
                        <div className="col-3 mt-5">
                            <Button
                                label="Download Report"
                                onClick={() => exportToExcel(transformedData, 'Student_Wise_Errors_Report', columns)}
                                disabled={!filteredData.length}
                                className="p-button-secondary mr-2"
                                style={{
                                    width: "137px",
                                    height: "40px",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    border: '1px solid #E6E8EA',
                                    backgroundColor: "#fff",
                                    color: "#076EFF",
                                    marginRight: "10px"
                                }}
                            />
                            <Button
                                label="View Analysis"
                                onClick={this.onViewAnalysis}
                                disabled={!selectedExam}
                                className="p-button-primary"
                                style={{
                                    width: "137px",
                                    height: "40px",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    border: '1px solid #E6E8EA',
                                    backgroundColor: "#076EFF",
                                    color: "#fff"
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className='datatable-report-demo mx-2'>
                    {filteredData.length > 0 && (
                        <DataTable
                            key={dataTableKey}
                            value={transformedData}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                            responsiveLayout="scroll"
                            className="p-datatable-custom"
                            loading={tableLoading}
                            loadingIcon="pi pi-spinner"
                            showLoader={false}
                        >
                            <Column header="S.No" body={(data, options) => options.rowIndex + 1} style={{ width: '70px', textAlign: 'center' }} />
                            <Column field="enrollmentId" header="Enrollment Code" style={{ textAlign: 'center' }} />
                            <Column field="studentName" header="Student Name" style={{ textAlign: 'center' }} />
                            <Column field="totalMarks" header="Total Marks (Overall Rank)" style={{ textAlign: 'center' }} />
                            {subjects.map(subjectName => [
                                <Column key={`${subjectName}_wrong`} field={`${subjectName}_wrong`} header={`${subjectName} Q.Nos WRONGLY ANSWERED`} style={{ textAlign: 'center' }} />,
                                <Column key={`${subjectName}_notAttempted`} field={`${subjectName}_notAttempted`} header={`${subjectName} Q.Nos NOT ATTEMPTED`} style={{ textAlign: 'center' }} />
                            ])}
                        </DataTable>
                    )}
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {tableLoading && <LoadingComponent />}
            </div>
        );
    }
}

export default StudentWiseErrorsReport;